export const getIsLockedValues = (isUnpaidAccount: boolean) => {
  const isMp3Locked = false;
  const isWavLocked = !!isUnpaidAccount;
  const isPdfLocked = !!isUnpaidAccount;
  const isStemsLocked = !!isUnpaidAccount;
  const isSamplePackLocked = !!isUnpaidAccount;

  return {
    isMp3Locked,
    isWavLocked,
    isPdfLocked,
    isStemsLocked,
    isSamplePackLocked,
  };
};
